import { render, staticRenderFns } from "./LabelExistsAlert.vue?vue&type=template&id=728b4c6e&scoped=true&"
import script from "./LabelExistsAlert.vue?vue&type=script&lang=ts&"
export * from "./LabelExistsAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728b4c6e",
  null
  
)

export default component.exports